import { render, staticRenderFns } from "./relatedComplianceInfoModal.vue?vue&type=template&id=c92051cc&scoped=true"
import script from "./relatedComplianceInfoModal.vue?vue&type=script&lang=js"
export * from "./relatedComplianceInfoModal.vue?vue&type=script&lang=js"
import style0 from "./relatedComplianceInfoModal.vue?vue&type=style&index=0&id=c92051cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92051cc",
  null
  
)

export default component.exports